export const getChange = (origNum, newNum) => {
    return origNum ? (newNum - origNum) / origNum : 0;
};
